var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"doughnut-container"},[_c('div',{staticClass:"doughnut-label"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('div',{staticClass:"doughnut-sublabel"},[_vm._v(" "+_vm._s(_vm.sublabel)+" ")])]),_c('Doughnut',{staticClass:"doughnut",attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }